<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Import Export Map
                </h4>
                <button type="button" class="close pull-right" (click)="staticModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="medium-padding remove-margin">
                    <form [formGroup]="formGroup">
                        <p>Choose the export map Excel file you want to import and then click Import</p>
                        <div class="row">
                            <div class="offset-md-1 col-md-9">                                
                                <button id="btnBrowse" class="btn btn-success">Browse</button>
                                <dx-file-uploader
                                    #dxFileUploader  
                                    dialogTrigger="#btnBrowse"      
                                    [visible]="false"                            
                                    [multiple]="false"     
                                    [allowedFileExtensions]="['.xlsx']"
                                    accept=".xlsx"
                                    [(value)]="dxFileUploadValue"
                                    uploadMode="useButtons"                                    
                                    (onValueChanged)="onDxValueChanged($event)"
                                    (onUploadStarted)="onDxUploadStarted($event)"                                      
                                    (onUploaded)="onDxUploaded()"
                                    (onUploadError)="onDxUploadError($event)">
                                </dx-file-uploader>                                
                                <span *ngIf="fileName" class="text-secondary padding-top-15" style="margin-left: 10px">{{ fileName }}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="staticModal.hide()">Cancel</button>
                <button class="btn btn-success" (click)="dxUpload()" [disabled]="!hasQueuedFileUpload || uploadInProgress">
                    <span *ngIf="uploadInProgress" class="sp-icon-loader-button-secondary u-alignMiddle"></span> 
                    {{uploadInProgress? 'Importing...': 'Import'}}
                </button>                
            </footer>
        </div>
    </div>
</div>
